export const actionTypes = {
    FetchPackages: 'FETCH_PACKAGES_SMART_REPAIR',
    FetchPackage: 'FETCH_PACKAGE_SMART_REPAIR',
    AddPackage: 'ADD_PACKAGE_SMART_REPAIR',
    RemovePackage: 'REMOVE_PACKAGE_SMART_REPAIR',
    UpdatePackage: 'UPDATE_PACKAGE_SMART_REPAIR',
    FetchedPackages: 'FETCHED_PACKAGES_SMART_REPAIR',
    FetchedPackage: 'FETCHED_PACKAGE_SMART_REPAIR',
    UpdatedPackage: 'UPDATED_PACKAGE_SMART_REPAIR',
    AddedPackage: 'ADDED_PACKAGE_SMART_REPAIR',
    FetchPackageFailed: 'FETCH_PACKAGE_FAILED_SMART_REPAIR',
    UpdatePackageFailed: 'UPDATE_PACKAGE_FAILED_SMART_REPAIR',
    AddPackageFailed: 'ADD_PACKAGE_FAILED_SMART_REPAIR',
    FetchPackagesFailed: 'FETCH_PACKAGES_FAILED_SMART_REPAIR',
    SetPackagesTotalRecords: 'SET_PACKAGES_TOTALRECORDS_SMART_REPAIR',
};

const initialState = {
    loading: false,
    packages: [],
    filtersContent: [],
    totalRecords: 0,
    package: null,
    error: null,
};

export function packageSmartRepairReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FetchPackages:
        case actionTypes.FetchPackage: {
            return {
                ...state,
                loading: true,
                package: null,
                error: null,
            };
        }
        case actionTypes.AddPackage:
        case actionTypes.RemovePackage:
        case actionTypes.UpdatePackage: {
            return {
                ...state,
                loading: true,
                error: null,
            };
        }
        case actionTypes.FetchedPackages: {
            return {
                ...state,
                loading: false,
                packages: action.payload.packages,
                totalRecords: action.payload.count,
                filtersContent: action.payload.filters,
            };
        }
        case actionTypes.FetchedPackage: {
            return {
                ...state,
                loading: false,
                package: action.payload.package,
                zone: action.payload.zone,
            };
        }
        case actionTypes.UpdatedPackage:
        case actionTypes.AddedPackage: {
            return {
                ...state,
                loading: false,
                package: action.payload,
            };
        }
        case actionTypes.FetchPackagesFailed:
        case actionTypes.FetchPackageFailed: {
            return {
                ...state,
                loading: false,
                packages: [],
                error: action.payload,
            };
        }
        case actionTypes.UpdatePackageFailed:
        case actionTypes.AddPackageFailed: {
            return {
                ...state,
                loading: false,
            };
        }
        case actionTypes.SetPackagesTotalRecords: {
            return {
                ...state,
                totalRecords: action.payload,
            };
        }
        default:
            return state;
    }
}

export const actions = {
    fetchPackages: () => ({ type: actionTypes.FetchPackages }),
    fetchedPackages: (packages) => ({ type: actionTypes.FetchedPackages, payload: packages }),
    fetchPackage: () => ({ type: actionTypes.FetchPackage }),
    fetchedPackage: (result) => ({ type: actionTypes.FetchedPackage, payload: result }),
    fetchPackageFailed: (error) => ({ type: actionTypes.FetchPackageFailed, payload: error }),
    addPackage: () => ({ type: actionTypes.AddPackage }),
    removePackage: () => ({ type: actionTypes.RemovePackage }),
    updatePackage: () => ({ type: actionTypes.UpdatePackage }),
    updatedPackage: (result) => ({ type: actionTypes.UpdatedPackage, payload: result }),
    addedPackage: (result) => ({ type: actionTypes.AddedPackage, payload: result }),
    updatePackageFailed: (error) => ({ type: actionTypes.UpdatePackageFailed, payload: error }),
    addPackageFailed: (error) => ({ type: actionTypes.AddPackageFailed, payload: error }),
    fetchPackagesFailed: (error) => ({ type: actionTypes.FetchPackagesFailed, payload: error }),
    setPackagesTotalRecords: (totalRecords) => ({ type: actionTypes.SetPackagesTotalRecords, payload: totalRecords }),
};

export const getPackagesTree = (packages, packageId) => {
    const options = [];
    let selectedPackage = null;

    packages.forEach((item) => {
        // initialise data
        if (packageId && packageId === item.id) {
            selectedPackage = { name: item.name, id: item.id };
        }
        // check exist category
        const newPackage = options.filter((option) => options.length > 0 && option.code === item.packageCategory.id);

        if (newPackage.length > 0) {
            options.forEach((option) => {
                if (option.code === item.packageCategory.id) {
                    option.package.push({
                        name: item.name,
                        id: item.id,
                    });
                }
            });
        } else {
            options.push({
                cname: item.packageCategory.name,
                code: item.packageCategory.id,
                package: [
                    {
                        name: item.name,
                        id: item.id,
                    },
                ],
            });
        }
    });

    return [options, selectedPackage];
};
